import script from "./Log.vue?vue&type=script&setup=true&lang=js"
export * from "./Log.vue?vue&type=script&setup=true&lang=js"

import "./Log.vue?vue&type=style&index=0&id=a84e61a8&lang=css"

const __exports__ = script;

export default __exports__